module.exports = __webpack_public_path__ + "img/keycard.4181a615.png";